<template>
    <div
        :class="{ error: validation && validation.$error }"
        class="time-select-wrap"
    >
        <label :for="id">
            {{ label }}
        </label>

        <select
            :id="id"
            :value="value"
            @change="$emit('input', $event.target.value)"
            @blur="validation && validation.$touch()"
        >
            <option value="" default disabled>Select time</option>
            <option v-for="(option, key) in options" :key="key" :value="key">
                {{ option }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'TimeSelectWrap',

    props: {
        value: {
            validator: (value) => typeof value === 'string' || value === null,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        validation: {
            type: Object,
            required: false,
            default: () => {},
        },
        options: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.time-select-wrap {
    width: 100%;
    // max-width: 10rem;
    max-width: 307.88px; // match calendar below
    position: relative;

    label {
        visibility: hidden;
    }
    select {
        padding: 0.5rem 1rem;
        margin: 0;
        line-height: 44px;
        height: 44px;
        border: 1px solid $color-light-gray;
        border-radius: $rounded;
        background-color: $color-font-light;
        width: 100%;
        min-width: 100%;
        font-size: $font-size-base;
        line-height: 1;
        font-family: $font-family;
        color: $color-font-dark;
        outline-color: $color-highlight;

        // remove normal dropdown button
        appearance: none;
        &::-ms-expand {
            display: none;
        }
    }

    // add custom dropdown button
    &:after {
        content: '<>';
        font: 17px 'Consolas', monospace;
        color: #333;
        transform: rotate(90deg);
        right: 11px;

        // adjust position
        top: 50%;
        padding: 0 0 2px;

        position: absolute;
        pointer-events: none;
    }

    &.error {
        select {
            border-bottom-color: $color-error;
            outline-color: $color-error;
        }
    }
}
</style>
